import { useCurrentEnvironment } from '@/react/hooks/useCurrentEnvironment';
import { Environment } from '@/react/portainer/environments/types';
import { isKubernetesEnvironment } from '@/react/portainer/environments/utils';

import { PageHeader } from '@@/PageHeader';

import { EnvironmentRegistriesDatatable } from './EnvironmentRegistriesDatatable';

export function ListView() {
  const { data: environment } = useCurrentEnvironment();
  const registryPolicy = getRegistryPolicy(environment);
  return (
    <>
      <PageHeader
        title="Environment registries"
        breadcrumbs="Registry management"
        reload
      />

      <EnvironmentRegistriesDatatable registryPolicy={registryPolicy} />
    </>
  );
}

function getRegistryPolicy(environment?: Environment) {
  if (!environment) {
    return undefined;
  }
  // for kube orchestrator, get the k8sRegistryPolicy
  if (isKubernetesEnvironment(environment.Type)) {
    return environment.Policies?.k8sRegistryPolicy;
  }
  // otherwise get the dockerRegistryPolicy
  return environment.Policies?.dockerRegistryPolicy;
}
